'use strict';

frontendApp.filter('truncate', [function () {

  return function (text, length) {

    var txtLen = 0;
    if (text) {
      txtLen = text.length;
    }

    if (txtLen > length) {
      return "..." + text.substring(txtLen - length);
    } else {
      return text;
    }
  };

}]);
